import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "primevue/resources/themes/arya-blue/theme.css";
import "primevue/resources/primevue.min.css";
import PrimeVue from "primevue/config";
import ToastService from "primevue/toastservice";

const app = createApp(App);

app.use(store);
app.use(router);
app.use(PrimeVue);
app.use(ToastService);

import Toast from "primevue/toast";
app.component("PrimeToast", Toast);

import Button from "primevue/button";
app.component("PrimeButton", Button);

import InputText from "primevue/inputtext";
app.component("PrimeInput", InputText);

import DataTable from "primevue/datatable";
app.component("PrimeDataTable", DataTable);

import Column from "primevue/column";
app.component("PrimeColumn", Column);

import ColumnGroup from "primevue/columngroup";
app.component("PrimeColumnGroup", ColumnGroup);

import Row from "primevue/row";
app.component("PrimeRow", Row);

import Dialog from "primevue/dialog";
app.component("PrimeDialog", Dialog);

import Dropdown from "primevue/dropdown";
app.component("PrimeDropdown", Dropdown);

import Calendar from "primevue/calendar";
app.component("PrimeCalender", Calendar);

app.mount("#app");
